import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  column: {
    display: 'flex',
  },
  label: {
    display: 'flex',
    minWidth: 78,
  },
  // row: {
  //   display: 'flex',
  //   flex: 1,
  //   flexWrap: 'wrap',
  //   '> *': {
  //     lineHeight: '24px',
  //   },
  //   '>div': {
  //     borderRight: `1px ${theme.palette.divider} solid`,
  //     padding: `${theme.spacing(3)} ${theme.spacing(2)}`,
  //   },
  //   alignContent: 'flex-start',
  //   alignItems: 'center',
  // },
  textPaddingAfter: {
    paddingRight: theme.spacing(0.5),
  },
  highlightText: {
    color: theme.palette.info.main,
  },
  twoLines: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
}));

const MemoTarget = ({ memoTarget }: { memoTarget?: string }) => {
  const { classes, cx } = useStyles();

  if (!memoTarget) {
    return <></>;
  }

  return (
    <>
      <Box className={cx(classes.column)}>
        <Typography className={cx(classes.label, classes.textPaddingAfter)} variant='bodyRegular'>
          Add note:
        </Typography>
        <Typography
          className={cx(classes.textPaddingAfter, classes.highlightText, classes.twoLines)}
          variant='bodyMedium'
        >
          {memoTarget}
        </Typography>
      </Box>
    </>
  );
};

export default MemoTarget;
